import React from "react"

const skillsItems =[
  {
    id:1,
    imageUrl:"/images/skills/climate.png",
    imageAlt:"climate justice",
  },
  {
    id:2,
    imageUrl:"/images/skills/sustainability.png",
    imageAlt:"sustainability",
  },
  {
    id:3,
    imageUrl:"/images/skills/gender-equality.png",
    imageAlt:"gender equality",
  },
  {
    id:4,
    imageUrl:"/images/skills/refugees.png",
    imageAlt:"refugees",
  },
  {
    id:5,
    imageUrl:"/images/skills/zero-waste.png",
    imageAlt:"zero waste ",
  },
  {
    id:6,
    imageUrl:"/images/skills/black-lives.png",
    imageAlt:"black lives",
  },
  {
    id:7,
    imageUrl:"/images/skills/child-protection.png",
    imageAlt:"child protection",
  },
  {
    id:8,
    imageUrl:"/images/skills/animal-rights.png",
    imageAlt:"animal rights",
  },
  {
    id:9,
    imageUrl:"/images/skills/biodiversity.png",
    imageAlt:"biodiversity",
  },
  {
    id:10,
    imageUrl:"/images/skills/community-dev.png",
    imageAlt:"community development",
  },



]
export default skillsItems
